import { computed, inject, Injectable, resource } from '@angular/core';
import {
  PricingModel,
  PricingModelPayload,
} from '../../models/pricing-model.model';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PricingModelService {
  private http = inject(HttpClient);

  pricingModels = resource({
    params: () => ({}),

    loader: () => this.fetchPricingModels(),
  });

  private fetchPricingModels(): Promise<PricingModel[]> {
    return firstValueFrom(
      this.http.get<PricingModel[]>('/quotes-api/pricing-models/'),
    );
  }

  pricingModelsById = computed(() => {
    if (this.pricingModels.hasValue()) {
      return this.pricingModels.value().reduce(
        (acc, pricingModel) => {
          acc[pricingModel.id] = pricingModel;
          return acc;
        },
        {} as Record<string, PricingModel>,
      );
    }
    return {};
  });

  activePricingModels = computed(() => {
    if (this.pricingModels.hasValue()) {
      return this.pricingModels
        .value()
        .filter((pricingModel) => pricingModel.is_active);
    }
    return [];
  });

  selectOptions = computed<Array<{ id: number | null; name: string }>>(
    // Provide a set of options for primeng select components
    () => {
      return [
        { id: null, name: 'Manual' },
        ...this.activePricingModels().map((model) => {
          return { id: model.id, name: model.name };
        }),
      ];
    },
  );

  async createPricingModel(
    pricingModel: PricingModelPayload,
  ): Promise<PricingModel> {
    const ret = await firstValueFrom(
      this.http.post<PricingModel>(`/quotes-api/pricing-models/`, pricingModel),
    );
    this.pricingModels.reload();
    return ret;
  }

  async patchPricingModel(
    id: number,
    pricingModel: Partial<PricingModelPayload>,
  ): Promise<PricingModel> {
    const ret = await firstValueFrom(
      this.http.patch<PricingModel>(
        `/quotes-api/pricing-model/${id}/`,
        pricingModel,
      ),
    );
    this.pricingModels.reload();
    return ret;
  }
}
